import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import SettingsPage from '../../partials/SettingsPage';
import LoadingSpinner from '../../partials/LoadingSpinner';
import PageHeader from '../../partials/PageHeader';

import ThresholdList from './ThresholdList';
import ThresholdSearch from './ThresholdSearch';
import ThresholdUpload from './ThresholdUpload';

import { Button, Text, Small, Panel, H3, H4, Badge, Box, Dropdown, Tabs } from '@bigcommerce/big-design';
import { ArrowDropDownIcon } from '@bigcommerce/big-design-icons';

import { locationsIndex } from '../../../redux/actions/locations';

const Thresholds = ({ payload, locations, loadLocations, thresholds }) => {
  const [activeAddress, setActiveAddress] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState('view');

  const tabItems = [
    { ariaControls: 'content1', id: 'view', title: 'Manage Existing Thresholds' },
    { ariaControls: 'content2', id: 'create', title: 'Search Products and Manage Thresholds' },
    { ariaControls: 'content3', id: 'upload', title: 'Upload Thresholds CSV' }
  ];

  useEffect(() => {
    if(thresholds.status === 'created') {
      setActiveTab('view');
    }
  }, [thresholds]);

  useEffect(() => {
    loadLocations(payload);
  }, []);

  const locationItems = () => {
    let items = [];

    locations.locations.map(location => 
      items.push(
        {
          content: location.label,
          onItemClick: () => setActiveAddress(location),
          hash: location.id
        }
      )
    );

    return items;
  }

  const description = () => {
    return(
      <>
        <Text>Select a BigCommerce inventory location to set target thresholds for that location.</Text>
        <Text>When suggesting purchase orders, your store's on hand inventory added with incoming inventory from open purchase orders, and compare that to the low and critical inventory thresholds created here.</Text>
        <Text>Critically low inventory levels will show red when viewing suggested purchase order lines.</Text>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return(
    <>
      <PageHeader stripeBackground='#5bc6cc' helpLink="bigcommerce/set-suggestion-thresholds/" />
      <SettingsPage title="Thresholds" description={description()}>
      
      <Panel>
        { locations.status === 'success' &&
          <div className="flex-1">
            <H4>BigCommerce Location</H4>
            <Dropdown
              items={locationItems()}
              maxHeight={250}
              placement="bottom-start"
              toggle={<Button iconRight={<ArrowDropDownIcon />}>{activeAddress?.label || "BigCommerce Location"}</Button>}
              disabled={thresholds.isFetching}
            />
          </div>
        }
        { locations.status !== 'success' &&
          <LoadingSpinner statusText="Loading locations" />
        }
      </Panel>

      <Panel>
        { !activeAddress &&
          <Box
            backgroundColor="warning10"
            border="box"
            borderRadius="normal"
            padding="medium"
          >
            <Text>Select a location to set product threshold levels.</Text>
          </Box>
        }
        { activeAddress &&
          <>
            <Tabs
              activeTab={activeTab}
              aria-label="Example Tab Content"
              id="tab-example"
              items={tabItems}
              onTabClick={setActiveTab}
            />
            { activeTab === 'view' &&
              <ThresholdList
                payload={payload}
                activeAddress={activeAddress}
              />
            }
            { activeTab === 'create' &&
              <ThresholdSearch
                payload={payload}
                activeAddress={activeAddress}
              />
            }
            { activeTab === 'upload' &&
              <ThresholdUpload
                payload={payload}
                activeAddress={activeAddress}
              />
            }
          </>
        }

      </Panel>

      </SettingsPage>
    </>
  )
}



const mapStateToProps = state => ({
  locations: state.locations,
  thresholds: state.thresholds,

});

const mapDispatchToProps = (dispatch) => ({
  loadLocations: (payload) => dispatch(locationsIndex(payload)),

});

export default connect(mapStateToProps, mapDispatchToProps)(Thresholds);



